import type { UpdateResolver } from '@urql/exchange-graphcache'
import type {
    ConfigureTeamsSettingsMutation,
    ConfigureZoomSettingsMutation,
    DisableRemovedCalendarMutationVariables,
    DisconnectAppMutationVariables,
} from '@/generated/gql/graphql'
import {
    GET_TEAMS_SETTINGS,
    GET_ZOOM_SETTINGS,
} from '@/providers/IntegrationsProvider/IntegrationsProvider'
import { invalidateCache } from '../utils/invalidateCache'

export const integrationsMutationUpdaters: Record<string, UpdateResolver> = {
    configureTeamsSettings: (
        parent: ConfigureTeamsSettingsMutation,
        _args,
        cache,
    ) => {
        cache.updateQuery(
            {
                query: GET_TEAMS_SETTINGS,
            },
            (data) => {
                if (data != null) {
                    data.teamsSettings = {
                        ...data.teamsSettings,
                        enableAutomaticRecording:
                            parent.configureTeamsSettings
                                ?.enableAutomaticRecording,
                    }
                    return data
                }
                return null
            },
        )
    },
    configureZoomSettings: (
        parent: ConfigureZoomSettingsMutation,
        _args,
        cache,
    ) => {
        cache.updateQuery(
            {
                query: GET_ZOOM_SETTINGS,
            },
            (data) => {
                if (data != null) {
                    data.zoomSettings = {
                        ...data.zoomSettings,
                        enableAutomaticRecording:
                            parent.configureZoomSettings
                                ?.enableAutomaticRecording,
                        usePmi: parent.configureZoomSettings?.usePmi,
                    }
                    return data
                }
                return null
            },
        )
    },
    connectEntraID: (result, args, cache) => {
        invalidateCache(cache, 'getEntraIDSettings')
    },
    integrationInstalled: (result, args, cache) => {
        invalidateCache(cache, 'appDirectory')
    },
    disconnectApp: (result, args: DisconnectAppMutationVariables, cache) => {
        cache.invalidate({
            __typename: 'App',
            id: args.input.app,
        })
    },
    disableCalendar: (
        _parent,
        args: DisableRemovedCalendarMutationVariables,
        cache,
    ) => {
        cache.invalidate({
            __typename: 'Calendar',
            id: args.input.id,
        })
    },
}

export const integrationsSubscriptionUpdaters: Record<string, UpdateResolver> =
    {
        integrationInstalled: (result, args, cache) => {
            invalidateCache(cache, 'appDirectory')
        },
    }
